async function renderTradeInDetails() {
  const urlParams = new URLSearchParams(window.location.search);
  const tradeinUuid = urlParams.get('tradeinuuid');
  const tradeInData = await getTradein(tradeinUuid);
  redirectIfNeeded(tradeInData);
  renderTradeInStatus(tradeInData);
  renderTradeinEstimate(tradeInData);
  renderTradeInCreditDetails(tradeInData);
}

function redirectIfNeeded(tradeInData) {
  if (!tradeInData && !Shopify.designMode) {
    window.location.href = appendReferrerToUrl(`${Shopify.routes.root}pages/trade-in-cart`);
    return;
  }

  if (tradeInData.tradeinType === 'insti' && !Shopify.designMode) {
    window.location = appendReferrerToUrl(`${Shopify.routes.root}pages/trade-in-status-instore?tradeinuuid=${tradeInData.uuid}`);
  }
}

async function renderTradeinEstimate(tradeInData) {
  const { tradeinItems } = tradeInData;
  const shippingEstimate = await getShippingEstimate(global.partnerUuid);
  const potentialCreditEl = document.querySelector('.trade-in-status__item-list .trade-in-credit-estimate');
  const estimatedShippingEl = document.querySelector('.trade-in-status__item-list .trade-in-shipping-estimate');
  const estimateGiftcardEl = document.querySelector('.trade-in-status__item-list .trade-in-giftcard-estimate');
  const {
    potentialCreditLow,
    potentialCreditHigh,
  } = calculatePotentialCredit(tradeinItems);
  const { giftcardEstimateLow, giftcardEstimateHigh } = calculateGiftcardEstimate({
    potentialCreditLow,
    potentialCreditHigh,
    shippingEstimate,
  });
  if (potentialCreditEl) setPrice(potentialCreditEl, [potentialCreditLow, potentialCreditHigh]);
  if (estimatedShippingEl) setShippingPrice(estimatedShippingEl, shippingEstimate);
  if (estimateGiftcardEl) setPrice(estimateGiftcardEl, [giftcardEstimateLow, giftcardEstimateHigh]);
}

function renderTradeInCreditDetails(tradeInData) {
  const giftcards = tradeInData.giftcards;
  if (!giftcards || !showCreditDetails) return;
  const creditDetailsWrapper = document.querySelector('.trade-in-status__credit-details');
  creditDetailsWrapper.classList.remove('hidden');
  giftcards.forEach((giftcard) => {
    const tradeInCreditDetailsEl = document.createElement('div');
    tradeInCreditDetailsEl.classList.add('trade-in-credit-details');

    const tradeInCreditDetailsInnerDiv = document.createElement('div');
    tradeInCreditDetailsEl.appendChild(tradeInCreditDetailsInnerDiv);

    const giftCardLastFour = document.createElement('div');
    giftCardLastFour.classList.add('trade-in-credit-details__gift-card-number', 'p-regular', 'p-bold');
    giftCardLastFour.textContent = `${TRADE_IN_STATUS_CONFIG.lastFourLabel}${giftcard.lastFour}`;

    const issuedOn = document.createElement('div');
    issuedOn.classList.add('trade-in-credit-details__issued-on');
    issuedOn.textContent = `${TRADE_IN_STATUS_CONFIG.issuedOnLabel}${DATE_TIME_FORMATS.PADDED_NUMERIC_DATE.format(new Date(giftcard.createdAtIso))}`;

    const startingBalance = document.createElement('div');
    startingBalance.classList.add('trade-in-credit-details__starting-balance', 'p-regular', 'p-bold');
    startingBalance.innerHTML = `${TRADE_IN_STATUS_CONFIG.startingBalanceLabel}<span class='p-regular'>${formatMoney(giftcard.amount)}</span>`;

    const remainingBalance = document.createElement('div');
    remainingBalance.classList.add('trade-in-credit-details__remaining-balance', 'p-regular', 'p-bold');
    remainingBalance.innerHTML = `${TRADE_IN_STATUS_CONFIG.remainingBalanceLabel}<span class='p-regular'>${
      giftcard.differentFromCurrentVendor ?
        'N/A' :
        formatMoney(giftcard.balanceAmount)
    }</span>`;

    tradeInCreditDetailsInnerDiv.appendChild(giftCardLastFour);
    tradeInCreditDetailsInnerDiv.appendChild(issuedOn);
    tradeInCreditDetailsInnerDiv.appendChild(startingBalance);
    tradeInCreditDetailsInnerDiv.appendChild(remainingBalance);

    const resendGiftcardExpirationDate = new Date();
    resendGiftcardExpirationDate.setDate(resendGiftcardExpirationDate.getDate() - numberOfDaysToDisplayResendLink)

    const compareDates = (date1, date2) => date1.getTime() < date2.getTime();

    if (compareDates(resendGiftcardExpirationDate, new Date(giftcard.createdAtIso)) || numberOfDaysToDisplayResendLink < 0) {
      const resendGiftCardEl = document.createElement('div');
      resendGiftCardEl.classList.add('trade-in-credit-details__resend-giftcard');
      resendGiftCardEl.textContent = TRADE_IN_STATUS_CONFIG.resendGiftcardLabel;
      resendGiftCardEl.addEventListener('click', () => resendGiftCardEmail(giftcard.uuid, giftcard.lastFour, giftcard.email));
      tradeInCreditDetailsEl.appendChild(resendGiftCardEl);
    }

    creditDetailsWrapper.appendChild(tradeInCreditDetailsEl);
  });
}

async function renderTradeInStatus(tradeInData) {
  const { uuid, tradeinItems, initiatedAt } = tradeInData;
  const tradeInNumberText = document.createTextNode(`TN-${getUuidPrefix(uuid).toUpperCase()}`);
  document.querySelector('.trade-in-number').appendChild(tradeInNumberText);

  const initiatedAtDate = DATE_TIME_FORMATS.PADDED_NUMERIC_DATE.format(new Date(initiatedAt));
  const tradeInInitiatedDate = document.createTextNode(initiatedAtDate);
  document.querySelector('.trade-in-initiated-date').appendChild(tradeInInitiatedDate);

  const tradeInItemList = document.querySelector('trade-in-item-list');
  tradeInItemList.renderTradeInItems(tradeinItems);

  renderTracker(tradeInData);
}

async function renderTracker(tradeIn) {
  const { state, trackingNumber, trackingUrl } = tradeIn;
  const stepper = document.querySelector('.trade-in-status__tracker-list');
  const list = stepper.childNodes;
  const statesMap = {
    "CREATING": 1,
    "CREATED": 1,
    "PENDING": 1,
    "KIT_NEEDED": 1,
    "KIT_ORDERED": 1,
    "KIT_PACKING": 1,
    "KIT_PACKED": 1,
    "CANCELED": 3,
    "TRADEIN_INBOUND": 5,
    "WAYSTATION_INBOUND": 5, // MITI for Arc Canada
    "TRADEIN_ARRIVED": 7,
    "TRADEIN_PROCESSING": 7,
    "MITI_RETURNING": 7,
    "MITI_RETURNED": 7,
    "WAYSTATION_ARRIVED": 7, // MITI for Arc Canada
    "DROPOFF_INITIATED": 7, // MITI for Arc Canada
    "DROPOFF_PROCESSING": 7, // MITI for Arc Canada
    "DROPOFF_READY": 7, // MITI for Arc Canada
    "TRADEIN_REVIEW": 9,
    "TRADEIN_PROCESSED": 9,
    "TRADEIN_SPECIALIST": 9,
    "PROCESSED": 9,
    "TRADEIN_COMPLETED": 11,
    "DROPOFF_COMPLETED": 11 // MITI for Arc Canada
  };
  if (!statesMap[state]) return;
  if (state === 'CANCELED') {
    // Display "request for trade-in" and "trade-in canceled" state
    for (let x = 0; x <= statesMap[state]; x++) {
      if (list[x].nodeName === 'LI') {
        list[x].classList.add('completed-step');
        if (list[x].className.includes('tradein-canceled')) list[x].classList.remove('hidden');
      }
    }
    // Iterate through the remaining states and hide
    for (let x = statesMap[state] + 1; x <= list.length; x++) {
      if (list[x]?.nodeName === 'LI') {
        list[x].classList.add('hidden');
      }
    }
    const canceledTradeinDescription = document.querySelector('.trade-in-status__canceled-trade-in-description');
    canceledTradeinDescription.classList.remove('hidden');
  } else {
    for (let x = 0; x <= statesMap[state]; x++) {
      if (list[x].nodeName === 'LI') {
        list[x].classList.add('completed-step');
        if (list[x].className.includes('tradein-shipped')) {
          const trackingElSpan = `<span class="p-bold">${trackingNumberLabel}:</span>`;
          const trackingElLink =`<a target="_blank" href="${trackingUrl}" >${trackingNumber}</a>`;
          const trackingInfo = `<div id="tracking-info">${trackingElSpan} ${trackingElLink}</div>`;
          const parser = new DOMParser();
          const element = parser.parseFromString(trackingInfo, 'text/html').querySelector('#tracking-info');
          list[x].appendChild(element);
        }
      }
    }
  }
}

renderTradeInDetails();

function getUuidPrefix(uuid) {
  let uuidPrefix = ""
  for(let character of uuid) {
    if (character === "-") break;
    uuidPrefix += character
  }
  return uuidPrefix;
}

const packingButton = document.querySelector('.trade-in-status__reprint-packing');
const shippingButton = document.querySelector('.trade-in-status__reprint-shipping');

packingButton.addEventListener('click', async function () {
  const spinner = document.querySelector('.packing-slip__spinner');
  packingButton.style.display = 'none';
  spinner.style.display = 'block';
  const urlParams = new URLSearchParams(window.location.search);
  const tradeinUuid = urlParams.get('tradeinuuid');
  const url = await generatePackingSlip(tradeinUuid);
  window.open(url, '_blank');
  packingButton.style.display = 'block';
  spinner.style.display = 'none';
});

shippingButton.addEventListener('click', async function () {
  const urlParams = new URLSearchParams(window.location.search);
  const tradeinUuid = urlParams.get('tradeinuuid');
  const url = await generateShippingLabel(tradeinUuid);
  window.open(url, '_blank');
});

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelector('.trade-in-status__breadcrumb')
    .classList[
      ORDER_TRADE_IN_LOOKUP_TOKEN_UTILS.getActiveToken() ? 'remove' : 'add'
    ]('hidden');
});
